import AppDispatcher from '../../../flux/dispatcher/dispatcher';
import LogoutConstant from '../../MainFrame/constants/Constants';
import restClient from '../../MainFrame/action/APIClient';

var UpdateDefaultRolesAction = function () {

}

UpdateDefaultRolesAction.prototype = {

	// POST updateDefaultRoles { domainName, roles, navigationSettings } — saves the Roles & access tab
	// (adds new roles and updates existing ones). Settles a promise so the tab can show its saving state.
	updateDefaultRoles: function (data) {
		return new Promise((resolve, reject) => {
			restClient.updateDefaultRoles(data, function (error, response) {
				if (error || response == null) {
					if (error && error.status === 401) {
						AppDispatcher.dispatch({
							actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
							data: error
						});
					}
					reject(error);
				} else {
					resolve(response);
				}
			})
		});
	},

	// DELETE deleteDefaultRoles?roleId=…&domainName=… — removes one saved role.
	deleteDefaultRole: function (data) {
		return new Promise((resolve, reject) => {
			restClient.deleteDefaultRoles(data, function (error, response) {
				if (error || response == null) {
					if (error && error.status === 401) {
						AppDispatcher.dispatch({
							actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
							data: error
						});
					}
					reject(error);
				} else {
					resolve(response);
				}
			})
		});
	}
}

export default new UpdateDefaultRolesAction();
